import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJHairstyleList from '../view/FJHairstyleList';
import FJActionHairstyleChanger from '../../../../redux/action/FJActionHairstyleChanger.js';

function FJHairstyleListContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const tab = useSelector(state => state.hairstyleChanger.tab);
    const maleHairstyle = useSelector(state => state.hairstyleChanger.hairInfo.male);
    const femaleHairstyle = useSelector(state => state.hairstyleChanger.hairInfo.female);

    const handleSelectHairstyle = useCallback(
        style => {
            dispatch(FJActionHairstyleChanger.setHairstyleAction(style));
        },
        [dispatch],
    );

    const hairstyle = useMemo(() => {
        if (tab === 0) {
            return femaleHairstyle;
        } else if (tab === 1) {
            return maleHairstyle;
        } else return undefined;
    }, [femaleHairstyle, maleHairstyle, tab]);

    return <FJHairstyleList value={hairstyle} onChange={handleSelectHairstyle} tab={tab} />;
}

export default FJHairstyleListContainer;
